/**
 * Minimal document-head helpers. Each setter keeps exactly one matching node:
 * it updates the first (including any host-provided tag) and removes duplicates.
 */

function upsert(selector: string, create: () => HTMLElement): HTMLElement {
  const matches = Array.from(document.head.querySelectorAll<HTMLElement>(selector))
  const [first, ...rest] = matches
  rest.forEach((node) => node.remove())
  if (first) return first
  const node = create()
  document.head.appendChild(node)
  return node
}

export function setMetaName(name: string, content: string) {
  const node = upsert(`meta[name="${name}"]`, () => {
    const meta = document.createElement('meta')
    meta.setAttribute('name', name)
    return meta
  })
  node.setAttribute('content', content)
}

export function setMetaProperty(property: string, content: string) {
  const node = upsert(`meta[property="${property}"]`, () => {
    const meta = document.createElement('meta')
    meta.setAttribute('property', property)
    return meta
  })
  node.setAttribute('content', content)
}

export function setCanonical(href: string) {
  const node = upsert('link[rel="canonical"]', () => {
    const link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    return link
  })
  node.setAttribute('href', href)
}

export function setTitle(title: string) {
  // Remove any extra <title> nodes so only one remains.
  const titles = Array.from(document.head.querySelectorAll('title'))
  titles.slice(1).forEach((node) => node.remove())
  document.title = title
}

export function setJsonLd(id: string, data: unknown) {
  const node = upsert(`script[type="application/ld+json"][data-seo="${id}"]`, () => {
    const script = document.createElement('script')
    script.setAttribute('type', 'application/ld+json')
    script.setAttribute('data-seo', id)
    return script
  })
  node.textContent = JSON.stringify(data)
}
